import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { claimListBO } from './claims.model';

@Injectable({
    providedIn: 'root'
})
export class ClaimslistService extends Subject<DataStateChangeEventArgs> {

    constructor(private http: HttpClient, public errorService: ErrorService,
    ) { super() }

    public execute(claimtstate: claimListBO): void {
        this.getTimesheetList(claimtstate).subscribe(x => super.next(x));
    }

    getTimesheetList(claimtstate?: claimListBO): Observable<DataStateChangeEventArgs> {
        return this.http.post<any>("api/Claims/getClaimList", claimtstate)
            .pipe(map(
                (response: any) =>
                    <any>{
                        result: response['result'],
                        count: response['count']
                    }
            ))
            .pipe(map((data: any) => {
                data.result = this.getData(data);
                return data;
            }))
    }

    getData(data) {
        let getdata = data.result
        getdata.forEach(e => {
            e.checkBoxClick = false;
            return;
        })
        return getdata;
    }

}


